/**
 * @module builder
 */
import type { MoveableItem } from '../../index'

export function filterPending(item: MoveableItem): boolean {
  return item.pending === true
}
